import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SUPERADMIN_ALL_ACTIVE_VENDORS,
  SUPERADMIN_ALL_PENDING_VENDORS,
  SUPERADMIN_VENDORS_SINGLE_REVIEW,
  SUPERADMIN_GET_ALL_DINER_ID,
  SUPERADMIN_VENDORS_OPEN_ISSUES,
  SUPERADMIN_SINGLE_VENDORS_OPEN_ISSUES,
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - GET ALL ACTIVE VENDORS ACTION
 *****************************************/
export const get_all_admin_active_vendors =
  (token, actionBy, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_active_vendors = await axios.get(
        `${serverApi}/admin/restaurant?status=ACTIVE${
          actionBy ? `&startDate=${startDate}&endDate=${endDate}` : ""
        }`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_active_vendors.status === 200) {
        dispatch({
          type: SUPERADMIN_ALL_ACTIVE_VENDORS,
          payload: get_active_vendors.data,
        });
        dispatch({ type: CLEAR_LOADER });
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL PENDING VENDORS ACTION
 *****************************************/
export const get_all_admin_pending_vendors =
  (token, actionBy, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_pending_vendors = await axios.get(
        `${serverApi}/admin/restaurant?status=PENDING${
          actionBy ? `&startDate=${startDate}&endDate=${endDate}` : ""
        }`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_pending_vendors.status === 200) {
        dispatch({
          type: SUPERADMIN_ALL_PENDING_VENDORS,
          payload: get_pending_vendors.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - FILTER ACTION FOR PENDING VENDORS
 * *****************************************/
export const admin_pending_vendor_filter =
  (token, actionBy, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const get_pending_vendors = await axios.get(
        `${serverApi}/admin/restaurant?status=PENDING&${
          actionBy ? `startDate=${startDate}&endDate=${endDate}` : ""
        }`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_pending_vendors.status === 200) {
        dispatch({
          type: SUPERADMIN_ALL_PENDING_VENDORS,
          payload: get_pending_vendors.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET UPDATE FLAG BLOCK ACTION
 *****************************************/
export const update_flag_block_vendoradmin =
  (formData, vendor_id, token, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_vendor_profile = await axios.patch(
        `${serverApi}/vendor-user/${vendor_id}`,
        formData
      );
      if (update_vendor_profile.status === 200) {
        // dispatch(get_all_admin_pending_vendors(token));
        // dispatch(get_all_admin_active_vendors(token));
        // dispatch({ type: CLEAR_LOADER });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_flag_block_merchant =
  (formData, vendor_id, token, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_vendor_profile = await axios.patch(
        `${serverApi}/admin/vendor-user/${vendor_id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (update_vendor_profile.status === 200) {
        callback();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL Single Rating Review ACTION
 *****************************************/
export const get_vendor_single_rating_review =
  (data, type, onCallBack) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_single_rating_review = await axios.get(
        `${serverApi}/review-rating?vendor_id=${data.vendor_id}&type=${type}`
      );
      if (get_single_rating_review.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_VENDORS_SINGLE_REVIEW,
          payload: get_single_rating_review.data,
        });
        onCallBack();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL ACTIVE VENDORS ACTION
 *****************************************/
export const send_sms_to_vendors =
  (formData, token, successCallback) => async (dispatch) => {
    try {
      let send_sms_to_vendors = await axios.post(
        `${serverApi}/admin/sms`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (send_sms_to_vendors.status === 201) {
        Alert.success(`<h4>SMS Send Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        successCallback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************************
 * @DESC - GET ALL SUPER ADMIN VENDOR OPEN ISSUES ACTION
 ********************************************************/
export const superadmin_vendor_open_issue =
  (data, query, token, onSuccessIssue) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let superadmin_vendor_open_issue = await axios.get(
        `${serverApi}/admin/issues-suggestions${
          data === 11 ? "" : `?status=${data}`
        }`,
        {
          params: { ...query },
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      // console.log(superadmin_vendor_open_issue.data);
      if (superadmin_vendor_open_issue.status === 200) {
        dispatch({
          type: SUPERADMIN_VENDORS_OPEN_ISSUES,
          payload: superadmin_vendor_open_issue.data,
        });
        dispatch({ type: CLEAR_LOADER });
        onSuccessIssue();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************************
 * @DESC - GET ALL SUPER ADMIN VENDOR OPEN ISSUES ACTION
 ********************************************************/
export const superadmin_vendor_Single_open_issue =
  (
    data,
    token,
    onSuccessIssue
    // onErrorIssue
  ) =>
  async (dispatch) => {
    try {
      let superadmin_single_vendor_open_issue = await axios.get(
        `${serverApi}/admin/issues-suggestions/${data}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (superadmin_single_vendor_open_issue.status === 200) {
        dispatch({
          type: SUPERADMIN_SINGLE_VENDORS_OPEN_ISSUES,
          payload: superadmin_single_vendor_open_issue.data,
        });
        onSuccessIssue();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onErrorIssue();
    }
  };

/***************************************
 * @DESC - UPDATE ALL SUPER ADMIN VENDOR OPEN ISSUES ACTION
 *****************************************/
export const update_super_admin_open_issues =
  (formData, token, issueId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let update_super_admin_open_issues = await axios.patch(
        `${serverApi}/admin/issues-suggestions/${issueId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_super_admin_open_issues.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Issue Status Update Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - COMMENT VENDOR TICKET ACTION
 *****************************************/
export const comment_super_admin_open_issues =
  (formData, token, issueId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let comment_super_admin_open_issues = await axios.patch(
        `${serverApi}/admin/issues-suggestions/${issueId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (comment_super_admin_open_issues.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>comment Add Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        // dispatch(superadmin_vendor_Single_open_issue(issueId, token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET PERTICULAR DINER TICKET ACTION
 *****************************************/
export const get_vendor_diners_information =
  (vendorId, countryCode, mobileNumber, token, requestName) =>
  async (dispatch) => {
    let code = countryCode.replace("+", "");
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let get_vendor_diners_information = await axios.get(
        `${serverApi}/admin/user-service?number=${
          code + mobileNumber
        }&diner=true`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_vendor_diners_information.status === 200) {
        dispatch({
          type: SUPERADMIN_GET_ALL_DINER_ID,
          payload: get_vendor_diners_information.data[0],
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL ACTIVE VENDORS ACTION
 *****************************************/
export const superadmin_approved_notapproved =
  (formData, vendorId, token, onCallback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let superadmin_approved_notapproved = await axios.patch(
        `${serverApi}/admin/restaurant/${vendorId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (superadmin_approved_notapproved.status === 200) {
        onCallback();
        dispatch(get_all_admin_active_vendors(token));
        dispatch(get_all_admin_pending_vendors(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - UPDATE ON HOLD VENDORS ACTION
 *****************************************/
export const update_on_hold_vendors_info =
  (formData, vendorId, token, onCallback) => async (dispatch) => {
    try {
      let update_on_hold_vendors = await axios.patch(
        `${serverApi}/admin/restaurant/${vendorId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (update_on_hold_vendors.status === 200) {
        Alert.success(`<h4>On Hold Information Send Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onCallback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - ADD DINER RESERVATION VENDORS ACTION
 *****************************************/
export const super_admin_add_diner_reservation =
  (formData, token, onCallback) => async (dispatch) => {
    try {
      let admin_add_diner_reservation = await axios.post(
        `${serverApi}/admin/diner`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (admin_add_diner_reservation.status === 201) {
        Alert.success(`<h4>Diner add successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onCallback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - UPDATE DINER INFORMATION ADMIN ACTION
 *****************************************/
export const update_diner_info_by_admin =
  (formData, token, dinerId, onCallback) => async (dispatch) => {
    try {
      let update_diner_info_by_admin = await axios.patch(
        `${serverApi}/admin/diner/${dinerId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (update_diner_info_by_admin.status === 200) {
        Alert.success(`<h4>Diner information updated successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onCallback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - UPDATE DINER INFORMATION ADMIN ACTION
 *****************************************/
export const update_diner_review_status =
  (formData, token, dinerId, onCallback) => async (dispatch) => {
    try {
      let update_diner_review_status = await axios.patch(
        `${serverApi}/admin/review-rating/${dinerId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (update_diner_review_status.status === 200) {
        Alert.success(`<h4>Review status updated successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onCallback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - ADD REVIEW FOR VENDOR SIDE
 *****************************************/
export const add_review_for_vendor_side =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_review_for_vendor_side = await axios.post(
        `${serverApi}/review-rating`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_review_for_vendor_side.data.code === 400) {
        dispatch({ type: CLEAR_LOADER });
        Alert.error(`<h4>Review user not found</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Add Review Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
      // if (add_review_for_vendor_side.status === 201) {
      //   dispatch({ type: CLEAR_LOADER });
      //   Alert.success(`<h4>Add Review Successfully</h4>`, {
      //     position: "top-right",
      //     effect: "bouncyflip",
      //     beep: true,
      //     html: true,
      //     timeout: 3000,
      //     offset: 35,
      //   });
      //   onSuccess();
      // }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/******************************************************
 * @DESC - ADMIN RESET PENDING ACTIVE PASSWORD ACTION
 ******************************************************/
export const admin_reset_password_pending_active_rq =
  (formData, token, successCallback, onErrorCallback) => async (dispatch) => {
    try {
      let reset_pending_active_password = await axios.post(
        `${serverApi}/admin/reset-password?vendor=true`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (reset_pending_active_password.status === 201) {
        successCallback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorCallback(err);
    }
  };
